import { createSelector } from 'reselect';

import { AppState } from '../../store/models/app-state';

const activitiesState = (state: AppState) => state.activities.items;

export const activitiesSelector = createSelector(activitiesState, activities => activities.sort((a, b) => a.id - b.id));
